import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Button, Icon } from 'antd';
import { tokens } from 'src/design-system';

const styles = theme => ({
  modalDiv: {
    maxWidth: '350px',
    '& .ant-modal-content': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '10px 25px',
    },
    '& .ant-modal-body': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '15px',
    },
    '& .ant-modal-footer': {
      borderTop: 0,
      padding: 0,
    },
    '& .ant-modal-close': {
      display: 'none',
    },
  },
  iconStyle: {
    fontSize: '70px',
    color: 'rgb(82, 196, 26)',
  },
  successHeading: {
    fontSize: `${tokens.fontSize.h2}px`,
    fontWeight: tokens.fontWeight.semibold,
    paddingTop: '4px',
    marginBottom: 0,
  },
  successMessage: {
    fontSize: `${tokens.fontSize.body}px`,
    fontWeight: tokens.fontWeight.semibold,
    paddingTop: '10px',
    textAlign: 'center',
  },
  redirectMessage: {
    fontSize: `${tokens.fontSize.small}px`,
    color: 'grey',
    paddingTop: '10px',
    fontStyle: 'italic',
  },
  okButton: {
    backgroundColor: '#FFF',
    color: '#1875F0',
    border: 0,
    fontWeight: tokens.fontWeight.semibold,
  },
});

class DeleteBidSuccessModal extends React.PureComponent<any, any> {

  render() {
    const { visible, handleOk, loading, ffName, classes, referenceNumber } = this.props;
    return (
      <Modal
        className={classes.modalDiv}
        visible={visible}
        footer={[
          <Button key="submit" size="large" className={classes.okButton}
          onClick={handleOk} loading={loading}>
            Okay
          </Button>,
        ]}
        >
          <Icon className={classes.iconStyle} type="check-circle" theme="filled"/>
          <p className={classes.successHeading}>Successfully Deleted</p>
          <p className={classes.successMessage}>
            You have successfully deleted the Bid sent
             by {ffName} for {referenceNumber}
          </p>
          <p className={classes.redirectMessage}>Now you are being redirected to Bid View</p>
      </Modal>
    );
  }
}

export default injectSheet(styles)(DeleteBidSuccessModal);
